export const c_table_m_tree_view_grid_td_data_label_GridTemplateColumns = {
  "name": "--pf-c-table--m-tree-view-grid--td--data-label--GridTemplateColumns",
  "value": "repeat(auto-fit, minmax(150px, 1fr))",
  "var": "var(--pf-c-table--m-tree-view-grid--td--data-label--GridTemplateColumns)"
};
export default c_table_m_tree_view_grid_td_data_label_GridTemplateColumns;